import Login from 'components/authentication/Login/Login';

export const LoginPage = () => {
    return <Login />;
};
